import { fromJS } from 'immutable';

import {
  updateThesaurusType,
  selectThesaurusGroupByIdType,
  updateThesaurusGroupByIdType,
  syncThesaurusItemsWithGrouopsType,
  clearAllSelectedItemsInThesaurusType,
} from '../../ListOfFiltersConstants';

import initialState from '../initialState';
import updateThesaurusHandler from './UpdateThesaurusHandler';
import selectThesaurusGroupByIdHandler from './SelectThesaurusGroupByIdHandler';
import syncThesaurusItemsWithGrouopsHandler, { setWholeThesaurusAs } from './SyncThesaurusItemsWithGrouopsHandler';

// eslint-disable-next-line import/prefer-default-export,default-param-last
export function thesaurusFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case updateThesaurusType: {
      return updateThesaurusHandler(state, action);
    }

    case updateThesaurusGroupByIdType: {
      const { key, filterId, data, rootGroupId } = action.payload;
      const resultPath = [key, 'items', filterId, 'thesaurusGroups', 'items', rootGroupId];

      return state.updateIn(resultPath, (group) => group.mergeDeep(fromJS(data)));
    }

    case selectThesaurusGroupByIdType: {
      return selectThesaurusGroupByIdHandler(state, action);
    }

    case syncThesaurusItemsWithGrouopsType: {
      return syncThesaurusItemsWithGrouopsHandler(state, action);
    }

    case clearAllSelectedItemsInThesaurusType: {
      const { key, filterId } = action.payload;
      const pathToFilter = [key, 'items', filterId];
      const pathToItems = [...pathToFilter, 'thesaurusGroups', 'items'];

      return setWholeThesaurusAs(state, pathToItems, pathToFilter, false);
    }

    default: {
      return state;
    }
  }
}
